import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CalendarView } from 'angular-calendar';
import { PointReminderModalService } from 'src/app/project/modules/points/point-reminders/point-reminder-modal/point-reminder-modal.service';
import { TReminder } from '../../../reminders.consts';
import { RemindersCalendarService } from '../../reminders-calendar.service';

@Component({
    selector: 'pp-reminders-calendar-month-view-cell',
    templateUrl: './reminders-calendar-month-view-cell.component.html',
    styleUrl: './reminders-calendar-month-view-cell.component.scss',
    standalone: false
})
export class RemindersCalendarMonthViewCellComponent {
  @Input() ppLocale: string;
  @Input() ppDay: any;
  @Input() ppView: CalendarView;
  @Output() ppViewChange = new EventEmitter<CalendarView>();
  @Input() ppViewDate: Date;
  @Output() ppViewDateChange = new EventEmitter<Date>();

  reminders: TReminder[] = [];

  constructor(
    private remindersCalendarService: RemindersCalendarService,
    private pointReminderModalService: PointReminderModalService,
  ) {}

  ngOnChanges(): void {
    this.setReminders();
  }

  openDay(day: Date, event: MouseEvent): void {
    event.stopPropagation();

    this.remindersCalendarService.changeMode(CalendarView.Day);
    this.ppViewDateChange.emit(day);
  }

  createReminder(): void {
    this.pointReminderModalService.showReminderModal({
      pointId: null,
      timestamp: this.ppDay.date.getTime(),
      skipTime: true,
    });
  }

  private setReminders(): void {
    this.reminders = this.remindersCalendarService.sortReminders(
      this.ppDay.events.map((event) => event.reminder),
    );
  }
}
